import { render, staticRenderFns } from "./pageGoodsModule.vue?vue&type=template&id=5ca34186"
import script from "./pageGoodsModule.vue?vue&type=script&lang=js"
export * from "./pageGoodsModule.vue?vue&type=script&lang=js"
import style0 from "./pageGoodsModule.vue?vue&type=style&index=0&id=5ca34186&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports